module.exports = __webpack_public_path__ + "img/Mika-Gomes.0b514c18.jpg";